const i18next = require('i18next')
const LanguageDetector = require('i18next-browser-languagedetector')
const Backend = require('i18next-xhr-backend');

module.exports = i18next
  .init({
    fallbackLng: 'fr',
    initImmediate: false,
    ns: ['commun', 'crm', 'gestion', 'reservation'],
    whitelist: ['fr', 'en'],
    defaultNS: 'commun',
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    }
  }, (err, t) => {
  })



// WEBPACK FOOTER //
// ./app/Utilitaire/Function/i18n.js